module.exports = __webpack_public_path__ + "img/ipc-logo-2.645cc625.png";